import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";

import './Sidebar.css';

import { clearAccounts, selectAccounts } from "../../features/manageAccounts/accountsSlice";
import { logout, selectToken } from "../../features/login/loginSlice";
import { clearUsers } from "../../features/manageUsers/manageUsersSlice.js";
import { clearUser, selectUser } from "../../features/home/userSlice.js";
import { clearBankSettings, loadBankSettings, selectBankSettings } from "../../features/manageBankSettings/bankSettingsSlice.js";
import { clearNewTransaction, clearTransactions } from "../../features/transactionList/transactionsSlice.js";
import { clearBranches } from "../../features/manageBranches/branchesSlice.js";
import { clearSupportTickets } from "../../features/supportTickets/supportTicketsSlice.js";

export default function Sidebar() {
    const dispatch = useDispatch();

    const token = useSelector(selectToken);

    const accounts = useSelector(selectAccounts);
    const userInfo = useSelector(selectUser);

    const userRole = userInfo.userRole;
    const bankId = userInfo.bankId;

    const bankSettings = useSelector(selectBankSettings);

    useEffect(() => {
        if (!bankSettings.id && userRole !== 'SUPERADMIN' && bankId && token) {
            dispatch(loadBankSettings({bankId, token}))
        }
    })

    const handleLogout = () => {
        dispatch(logout());
        dispatch(clearUser());
        dispatch(clearAccounts());
        dispatch(clearUsers());
        dispatch(clearNewTransaction());
        dispatch(clearTransactions());
        dispatch(clearBankSettings());
        dispatch(clearBranches());
        dispatch(clearSupportTickets());
    }

    return (
        <nav>
                <Link to={`../home`}><h3>{userRole === 'USER' ? "Accounts" : "Home"}</h3></Link>
                {userRole !== 'USER' ? "" : 
                <ul>
                    {Object.values(accounts).map(account => {
                        return <Link to={`../account/${account.accountId}`}><li id={account.accountId} key={account.accountId}>{account.accountType}</li></Link>
                    })}
                </ul>}
                <h3>Manage</h3>
                <ul>
                    {userRole === 'ADMIN' || (userRole === 'TELLER' && bankSettings.tellerDepositPermission) ? <Link to={`../${bankId}/deposit`}><li>Deposit</li></Link> : ""}
                    {(userRole === 'TELLER' && bankSettings.tellerWithdrawalPermission) || userRole === 'ADMIN' ? <Link to={`../${bankId}/withdrawal`}><li>Withdrawal</li></Link>: ""}
                    {userRole === 'ADMIN' || userRole === 'USER' || (userRole === 'TELLER' && bankSettings.tellerTransferPermission) ? <Link to={`../${bankId}/transfer`}><li>Transfer</li></Link> : ""}
                    {userRole === 'SUPERADMIN' ? <Link to={`../admin/banks`}><li>Banks</li></Link> : ""}
                    {userRole === 'ADMIN' || userRole === 'SUPERADMIN' ? <Link to={`../${bankId}/admin/branches`}><li>Branches</li></Link> : ""}
                    {userRole === 'ADMIN' || userRole === 'SUPERADMIN' ? <Link to={`../${bankId}/admin/users`}><li>Users</li></Link> : ""}
                    {userRole === 'ADMIN' || userRole === 'SUPERADMIN' ? <Link to={`../${bankId}/admin/accounts`}><li>Accounts</li></Link> : ""}
                </ul>
                <h3>Settings</h3>
                <ul>
                    {userRole === 'USER' ? <Link to={`../settings/accountInfo`}><li>Account Information</li></Link> : ""}
                    {userRole === 'USER' ? <Link to={`../documents/statements`}><li>Statements</li></Link> : ""}
                    {userRole === 'ADMIN' ? <Link to={`../${bankId}/admin/bank`}><li>Bank Settings</li></Link> : ""}
                    <Link to={`../settings`}><li>{userRole === 'ADMIN' ? 'User Settings' : 'Settings'}</li></Link>
                    <Link to={`../${bankId}/support`}><li>Support</li></Link>
                    <li onClick={handleLogout}>Logout</li>
                </ul>
        </nav>
    )
}